import { useEffect } from 'react';
import { openAccount } from '@/shell/AccountDialog';
import { queryClient } from '@/lib/queryClient';
import { navigate, useRoute } from '@/lib/router';
import { toast } from '@/lib/toast';
import { goConnect, myInboxQuery, refreshInboxes } from './queries';

// Finishes the trip to Google and back: confirms the connection, reopens where you started, and tidies the address
// bar. Also handles the one-click link in a reminder to connect Gmail (`?connect=gmail`). Failures arrive as
// `auth_error`, which the shell shows as an error toast.

export function GmailReturn() {
  const { params } = useRoute();
  const result = params.gmail;
  const connect = params.connect;

  useEffect(() => {
    if (!result) return;
    navigate({ params: { gmail: null } }, { replace: true });
    void refreshInboxes();
    if (result === 'connected') {
      toast('Your Gmail is connected', { icon: 'check-circle' });
      openAccount();
    } else if (result === 'account') {
      openAccount();
    } else if (result === 'shared') {
      toast('Shared inbox connected', { icon: 'check-circle' });
    } else if (result === 'crm') {
      toast('CRM address connected', { icon: 'check-circle' });
    }
  }, [result]);

  useEffect(() => {
    if (connect !== 'gmail') return;
    navigate({ params: { connect: null } }, { replace: true });
    let cancelled = false;
    queryClient
      .fetchQuery({ ...myInboxQuery, staleTime: 0 })
      .then((inbox) => {
        if (cancelled) return;
        const ready = inbox.mailbox && inbox.mailbox.live && inbox.mailbox.status === 'connected';
        if (inbox.configured && !ready) goConnect('personal');
        else openAccount();
      })
      .catch(() => {
        if (!cancelled) openAccount();
      });
    return () => {
      cancelled = true;
    };
  }, [connect]);

  return null;
}
